import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NzButtonSize, NzButtonModule } from 'ng-zorro-antd/button';
import { LambdaService } from './../../../shared/core/lambda.service';
import { AsyncPipe } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';

@Component({
  selector: 'app-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzButtonModule, NzWaveModule, NzIconModule, AsyncPipe],
})
export class SaveButtonComponent {
  @Input() size: NzButtonSize = 'default';

  isLoading$;

  constructor(private lambdaService: LambdaService) {
    this.isLoading$ = this.lambdaService.isLoading$;
  }
}
